import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';

import { ICodeValue, IValueObject } from '../../../../../type_definitions/datatypes';

export interface IBPMail {
  cc?:string;
  date?:number;
  editLink?:string;
  from?:string;
  fromAddress?: {
    manuallyAdded?:boolean;
    name?:string;
    nameAndCompany?:string;
    nameAndEmail?:string;
  };
  hideBpProfile?:boolean;
  hideForCustomer?:boolean;
  hideForVendor?:boolean;
  id:number;
  mailText?:string;
  mailType?:ICodeValue;
  parentMailId?:number;
  requestId?:number;
  sendSeparateMailToEachRecipient?:boolean;
  status?:IValueObject;
  subject?:string;
  to?:string;
}

export interface IBPMailResponse {
  currentPage?:number;
  numberOfPages?:number;
  totalData?:number;
  page: {
    mailsList: IBPMail[];
  }
}

@Injectable()
export class BPProfilesMailsDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getBPMails(profileId:number, page:number = 1):Promise<IBPMailResponse> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/mails`,
      { page },
      undefined,
      'Error getting mails'
    );
  }
}